<template>
  <div class="box7">
    <pageTitle
      title="对标企业需求<br/>4大热门AI技术全覆盖"
      text="4大技术覆盖90%的AI岗位需求，解锁多元化职业发展路径"
      titleColor="#FFFFFF"
      titColor="#FFFFFF"
    />

    <div class="skill-list">
      <div
        class="skill-card"
        v-for="(item, index) in skillList"
        :key="index"
      >
        <img class="skill-card__icon" :src="item.icon" alt="" />
        <div class="skill-card__body">
          <div class="skill-card__title-row">
            <h3 class="skill-card__title">{{ item.title }}</h3>
            <img
              class="skill-card__fire"
              src="../../../assets/coursePage/llm/box7/fire.png"
              alt=""
            />
          </div>
          <p class="skill-card__desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import ConsultBtn from "./ConsultBtn.vue";

export default {
  components: {
    pageTitle,
    ConsultBtn,
  },
  data() {
    return {
      skillList: [
        {
          icon: require("../../../assets/coursePage/llm/box7/icon-1.png"),
          title: "智能体（Agent）开发",
          desc: "开发智能客服、办公自动化智能体等，是企业AI转型的第一需求",
        },
        {
          icon: require("../../../assets/coursePage/llm/box7/icon-2.png"),
          title: "RAG检索增强生成",
          desc: "搭建企业专属知识库问答系统、内部文档助手等",
        },
        {
          icon: require("../../../assets/coursePage/llm/box7/icon-3.png"),
          title: "大模型微调",
          desc: "针对特定行业定制大模型，让AI完全适配企业业务精准输出内容",
        },
        {
          icon: require("../../../assets/coursePage/llm/box7/icon-4.png"),
          title: "多模态大模型开发",
          desc: "开发出文生图、文生视频、图文问答助手这类的AI应用",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box7 {
  position: relative;
  padding: 80px 32px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box7/bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  background-color: #3b7dff;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 44px;
    margin-top: 14px;
    opacity: 0.95;
  }

  .skill-list {
    position: relative;
    z-index: 1;
    margin-top: 48px;
  }

  .skill-card {
    display: flex;
    align-items: flex-start;
    min-height: 194px;
    margin-bottom: 24px;
    padding: 32px 32px 32px 24px;
    box-sizing: border-box;
    background: url("../../../assets/coursePage/llm/box7/card-bg.png")
      no-repeat center;
    background-size: 100% 100%;

    &:last-child {
      margin-bottom: 0;
    }

    &__icon {
      flex-shrink: 0;
      width: 120px;
      height: 120px;
      margin-top: 4px;
      object-fit: contain;
      position:relative;
      left:-6px;
    }

    &__body {
      flex: 1;
      min-width: 0;
      margin-left: 16px;
    }

    &__title-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__title {
      font-family: PingFangSC, PingFang SC;
      font-size: 34px;
      font-weight: 600;
      color: #072557;
      line-height: 48px;
    }

    &__fire {
      flex-shrink: 0;
      width: 60px;
      height: 60px;
      margin-left: 8px;
      object-fit: contain;
      position:relative;
      top:-6px;
    }

    &__desc {
      
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #00245a;
      line-height: 36px;
    }
  }

}
</style>
